export default {
  methods: {
    openLoading() {
      return this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)'
      })
    },
    todoApi(action) {
      this.$message.info(action ? `${action}：接口待接入` : '接口待接入')
    },
    applyMockPage(source) {
      const list = Array.isArray(source) ? source : []
      this.total = list.length
      const size = this.queryParams.pageSize || 10
      const index = this.queryParams.pageIndex || 1
      const start = (index - 1) * size
      this.tableData = list.slice(start, start + size)
    },
    formatMoney(fen) {
      return ((Number(fen) || 0) / 100).toFixed(2)
    },
    maskIdNumber(value) {
      if (!value || value.length < 8) return value || ''
      return value.substring(0, 4) + '****' + value.substring(value.length - 4)
    },
    handleCurrentChange() {
      this.GetData()
    },
    handleSizeChange(size) {
      this.queryParams.pageSize = size
      this.queryParams.pageIndex = 1
      this.GetData()
    }
  }
}
